// src/components/sections/ProductsSection.js
import React from 'react';
import { motion } from 'framer-motion';
import productsData from '../../data/products';
import ProductCard from '../cards/ProductCard';

// Animation variants for the container to orchestrate staggered animations.
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.2, // Time delay between each child's animation
    },
  },
};

// Animation variants for each individual product card.
const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
    },
  },
};

/**
 * ProductSection component displays a list of products with entrance animations.
 * @return {React.ReactElement} The ProductSection component.
 */
const ProductsSection = () => {
  return (
    <section id="продукция" className="py-16 bg-gray-50">
      <div className="container mx-auto px-6">
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.5 }}
          transition={{ duration: 0.5 }}
        >
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6">
            Наша <span className="text-orange-500">Продукция</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Широкий ассортимент текстильных строп для различных задач грузоподъема
          </p>
        </motion.div>

        <motion.div
          className="grid md:grid-cols-2 lg:grid-cols-3 gap-8"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
        >
          {productsData.map((product, index) => (
            <ProductCard key={index} product={product} variants={itemVariants} />
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default ProductsSection;
